/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const repeatMobileOrderItemModifierSchema = z.object({
	id: z.uuid().nullish(),
	amount: z.int(),
	size: z.uuid().nullish(),
	price: z.number().nullish(),
	internal_reason: z.string().nullish(),
});
